import { RootState } from "state/delegate";

let store: RootState;

export const setInMemoryStore = (newStore: RootState) => (store = newStore);

export const getInMemoryStore = () => store;
